var _title, _desc, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCaretIcon = function SvgCaretIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "12px",
    viewBox: "0 0 7 12",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Carret")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Samlagsvis---Sok",
    transform: "translate(-248.000000, -639.000000)",
    fill: "#69707F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dd",
    transform: "translate(0.000000, 565.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.894927,82.8407674 L251.753116,85.8980206 C251.613231,86.0339931 251.386672,86.0339931 251.246947,85.8980206 L248.104794,82.8407674 C247.965069,82.7047504 247.965069,82.4843329 248.104794,82.348316 L248.357866,82.1020792 C248.497591,81.9659736 248.724356,81.9659736 248.864172,82.1020792 L251.499997,84.6668367 L254.135913,82.1020792 C254.275615,81.9659736 254.502266,81.9659736 254.642037,82.1020792 L254.89511,82.348316 C255.034994,82.4844882 255.034994,82.7047504 254.894927,82.8407674 Z M248.105073,77.1592326 L251.246884,74.1019794 C251.386769,73.9660069 251.613328,73.9660069 251.753053,74.1019794 L254.895206,77.1592326 C255.034931,77.2952496 255.034931,77.5156671 254.895206,77.651684 L254.642134,77.8979208 C254.502409,78.0340264 254.275644,78.0340264 254.135828,77.8979208 L251.500003,75.3331633 L248.864087,77.8979208 C248.724385,78.0340264 248.497734,78.0340264 248.357963,77.8979208 L248.10489,77.651684 C247.965006,77.5155118 247.965006,77.2952496 248.105073,77.1592326 Z",
    id: "Carret",
    transform: "translate(251.500000, 80.000000) rotate(-180.000000) translate(-251.500000, -80.000000) "
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaretIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caret-icon.47167787.svg";
export { ForwardRef as ReactComponent };